export default __webpack_public_path__ + "backgroundForm.f157e90.png";